import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

export const ProductCard = ({ product, index = 0 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: index * 0.1 }}
      className="product-card group"
      data-testid={`product-card-${product.id}`}
    >
      <Link to={`/product/${product.id}`}>
        {/* Image */}
        <div className="image-zoom aspect-product relative bg-[#F2EFE9] mb-4 overflow-hidden">
          <img
            src={product.images[0]}
            alt={product.name}
            className="w-full h-full object-cover"
            data-testid={`product-image-${product.id}`}
          />
          {product.is_featured && (
            <span className="absolute top-4 left-4 px-3 py-1 bg-[#C6A87C] text-[#2C2420] text-xs uppercase tracking-wider">
              Featured
            </span>
          )}
        </div>

        {/* Details */}
        <div className="space-y-2">
          <p className="text-xs uppercase tracking-widest text-[#8C8580]">
            {product.category.replace(/-/g, ' ')}
          </p>
          <h3 className="font-heading text-lg text-[#2C2420] group-hover:text-[#C6A87C] transition-colors duration-300">
            {product.name}
          </h3>
          <p className="font-body text-base text-[#5D5550]" data-testid={`product-price-${product.id}`}>
            €{product.price.toFixed(2)}
          </p>
        </div>
      </Link>
    </motion.div>
  );
};
